import React from "react";
import {
  Popover as ChakraPopover,
  PopoverTrigger as ChakraPopoverTrigger,
  PopoverContent as ChakraPopoverContent,
} from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { remCalc } from "theme/utils";
import { SubNav } from "./sub-nav";
import { type NavTabProps } from "./data";
import { NavLink } from "./nav-link";
import { PlatformSubNav } from "./platform-sub-nav";

// Reset chakra-ui default animation variants
const noTransition = {
  exit: {
    opacity: 0,
    scale: 1,
    transition: {
      duration: 0,
    },
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0,
      ease: [0, 0, 0.2, 1],
    },
  },
};

type PopoverProps = {
  isActive?: boolean;
  isDimmed?: boolean;
  navItem: NavTabProps;
  contentWidth?: string;
  onOpen?: () => void;
};

export function Popover({ isActive, isDimmed, navItem, contentWidth, onOpen }: PopoverProps) {
  const { bgColor } = useColorTheme();

  return (
    <ChakraPopover gutter={0} trigger="hover" strategy="fixed" openDelay={0} closeDelay={0} onOpen={onOpen}>
      <ChakraPopoverTrigger>
        <NavLink as="button" type="button" isActive={isActive} isDimmed={isDimmed}>
          {navItem.label}
        </NavLink>
      </ChakraPopoverTrigger>

      <ChakraPopoverContent
        bg={bgColor}
        border="none" // Override default border
        borderTopRadius="none" // Override default border radius
        borderBottomRadius="bigger"
        minW={contentWidth} // Override default min width to avoid overflow
        maxW="100vw"
        pt={remCalc(24)}
        pb={remCalc(50)}
        pos="relative"
        overflow="hidden"
        zIndex="popover"
        variants={noTransition}
      >
        {navItem.type === "platform" ? <PlatformSubNav {...navItem} /> : <SubNav {...navItem} />}
      </ChakraPopoverContent>
    </ChakraPopover>
  );
}
